import { ListMain } from './components/containers';

export const AccountingSyncList = () => <ListMain />;
